import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ShiftsService } from 'src/app/services/apis/shifts.service';

@Component({
  selector: 'app-back-and-forth-warning',
  templateUrl: './back-and-forth-warning.component.html',
  styleUrls: ['./back-and-forth-warning.component.scss']
})
export class BackAndForthWarningComponent implements OnInit {

  constructor(
    private _shiftJavaService: ShiftsService,
    public _dialogRef: MatDialogRef<BackAndForthWarningComponent>
  ) { }

  ngOnInit(): void { }

  doNotShow() {
    this._shiftJavaService.setJson({ steptype: 'doNotShow', stepjson: true }).pipe().subscribe(() => {
      this._dialogRef.close(true);
    }, error => {
      this._dialogRef.close(false);
    });

    setTimeout(() => this._dialogRef.close(true), 250);
  }

}
